import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';

import { FaPencilAlt, FaTrashAlt, FaCloudDownloadAlt} from 'react-icons/fa';
import urlBase from './../api/UrlBase';

class TablaMaterial extends Component {
    render(){
        const {data, editar, eliminar} = this.props; 

        return (
            <div>
                  {
                    data.length>0 ? (   
                        <Table size="sm" striped bordered className="tabla-general">
                            <thead>
                                <tr>
                                    <th>Curso</th>
                                    <th className="ocultar-en-somen">Fecha</th>
                                    <th>Título</th>
                                    <th className="ocultar-en-somen">Descripción</th>
                                    <th className="text-center" style={{minWidth:100}}>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                            {data.map(b => {
                                return (
                                    <tr key={b.id}>
                                        <td><span className={b.curso===null?'letra-roja':null }>{b.curso!==null ? b.curso : 'Ciclo eliminado'}</span></td>
                                        <td className="ocultar-en-somen">{b.fecha}</td>
                                        <td>{b.titulo}</td>
                                        <td className="ocultar-en-somen">{b.descripcion}</td>
                                        <td className="text-center td-botones">
                                            <a href={urlBase+b.archivo} target="_blank" className="btn-tabla btn btn-primary" rel="noopener noreferrer" download="w3logo"><FaCloudDownloadAlt/></a>
                                            <Button color="secondary" className="btn-tabla"  onClick={()=>editar(b)} > <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla"  onClick={()=>eliminar(b.id)} ><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                )  
                            })} 
                            </tbody>
                        </Table>  
                    ) : (<div className="sin-registros">Sin registros</div>)
                }
            </div>
           
        );
    }
}
export default TablaMaterial;